import { Component, ViewEncapsulation } from '@angular/core';
@Component({
    selector: 'fe-standard-of-care',
    templateUrl: './standard-of-care.component.html',
    styleUrls: ['./standard-of-care.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class StandardOfCareComponent {
    breadcrumbs = [
        { label: 'fe_breadcrumb_about', url: 'about-us' },
        {
            label: 'fe_breadcrumb_standard_of_care',
            url: 'about-us-a/our-standard-of-care',
        },
    ];
}
